import {
  FontPairs,
  Palettes,
  TWebsiteTheme,
  TWebsiteThemeId,
} from '@bridebook/web/lib/wedding-website/types';

export const getThemeId = (theme: TWebsiteTheme): TWebsiteThemeId =>
  `${theme.palette}-${theme.font}`;

export const getThemeById = (themeId: TWebsiteThemeId): TWebsiteTheme => {
  const [palette, font] = themeId.split('-') as [Palettes, FontPairs];
  return { palette, font };
};

// this helper does the same as getThemeId, but there is no typing, so we can use it for checking if the theme is custom or not
// there is no types on values from redux
export const customThemeIdString = (palette: string, font: string): string => `${palette}-${font}`;
